import { render, staticRenderFns } from "./farm-root.vue?vue&type=template&id=4052f46e"
import script from "./farm-root.vue?vue&type=script&lang=js"
export * from "./farm-root.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports